const CATALYST_BASE_URL = 'https://appcatalyst.com.br';
const CATALYST_LOCALE_PATH = {
  pt: '/pt-BR',
  en: '/en-US',
  es: '/es-MX'
};

export const CATALYST_NAV_KEY = 'navigation.catalyst';

const catalystUrl = (language) => CATALYST_BASE_URL + CATALYST_LOCALE_PATH[language];

export default catalystUrl;
